module.exports = __webpack_public_path__ + "img/L3_Frame_Door.50cbb359.svg";